import React from "react";
import Content from "Types/Content";
import { RouteProps } from "react-router";
import styles from "Styles/developers.module.scss";
import JosueIMG from "ProfilePictures/Josue.png";

//En mi caso mezcle scss modules, clases de bootstrap, y atributo style para mostrar ambos casos de uso.

const JosueVitali: React.FC<RouteProps> = () => {
  return (
    <div
      className='container mt-5 bg-dark rounded position-relative'
      style={{ zIndex: -2 }}>
      <div className='row m-3'>
        <div className='col-md-3'>
          <div className='flex-direction-column'>
            <img
              className={`${styles.animate1s} rounded img-fluid mb-5 mt-5`}
              src='https://media-exp1.licdn.com/dms/image/C4D03AQFe9ChUFduYvg/profile-displayphoto-shrink_800_800/0/1615047853837?e=1634774400&v=beta&t=OpqlVm19mP44ab80h4lz5EJCBJ2P5xJFv3O2vekt0fY'
              alt=''
            />

            <h1
              className={`${styles.name} ${styles.animate} ${styles.defaultText}`}>{`<Josue Vitali />`}</h1>
            <p className={`${styles.defaultText} ${styles.animateP}`}>22yo</p>
          </div>
        </div>
        <div className='col-md-9'>
          <p
            className={`${styles.titles} ${styles.white} ${styles.defaultText} ${styles.animate} mt-5 font-italic`}>{`Formo parte del equipo Frontend`}</p>
          <div className='flex-direction-column align-items-end mt-5'>
            <ul>
              <li
                className={`${styles.parrafo} ${styles.defaultText} ${styles.animateP} text-justify col-md-12 col-sm-12 col-xl-4`}>
                Soy Josue trabajo en crombie sobre la parte del frontend, trato
                de especializarme en React porque es lo que más me gusta. Puedo
                hacer de todo un poco, y siempre trato de dar una mano si es
                necesaria.
              </li>
              <li
                className={`${styles.parrafo} ${styles.defaultText} ${styles.animateP} text-justify col-md-12 col-sm-12 col-xl-4 mt-3`}>
                Estudie casi 3 años Desarrollo de software, pero aprendi la
                mayoria de cosas utiles por mi cuenta, me encata React y JS en
                general Me queda mucho que aprender y no tengo drama en que me
                pregunten o preguntar cuando tengo alguna duda. Me gusta jugar,
                mirar anime, dibujar, boludear etc.
              </li>
            </ul>
          </div>
          <div className='position-relative'>
            <img
              className={`${styles.animate1s}`}
              style={{
                position: "absolute",
                bottom: "0px",
                right: "0px",
                zIndex: -1
              }}
              src={JosueIMG}
              alt=''
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default new Content({
  Component: JosueVitali,
  title: "Josue Vitali",
  route: "josue-vitali",
  tags: [
    "Frontend",
    "React Web",
    "Hooks",
    "DeTodoUnPoco",
    "C#",
    "CSS",
    "HTML",
    "UI",
    "UX"
  ]
});
